import { z } from "zod"

import { ProductFileType } from "@/screens/Products/components/Product/Information/types/productFile"

const ProductFilesSchema = z
  .object({
    fileType: z.nativeEnum(ProductFileType),
    file: z.instanceof(File),
    fileDescription: z.string().max(50, "File description must be at most 50 characters long").optional(),
  })
  .nullable()
  .superRefine((data, ctx) => {
    if (!data?.fileType) {
      ctx.addIssue({
        path: ["fileType"],
        code: z.ZodIssueCode.custom,
        message: "File type is required",
      })
    }
    if (!data?.file) {
      ctx.addIssue({
        path: ["file"],
        code: z.ZodIssueCode.custom,
        message: "File is required",
      })
    }
    if (
      (data?.fileType === ProductFileType.Labwork || data?.fileType === ProductFileType.Miscellaneous) &&
      (!data?.fileDescription || data?.fileDescription.trim().length === 0)
    ) {
      ctx.addIssue({
        path: ["fileDescription"],
        code: z.ZodIssueCode.custom,
        message: "File description is required for Labwork or Miscellaneous file types",
      })
    }
  })

export const ProductFilesFormSchema = z.record(ProductFilesSchema).superRefine((obj, ctx) => {
  for (const [key, value] of Object.entries(obj)) {
    if (
      (value?.fileType === ProductFileType.Labwork || value?.fileType === ProductFileType.Miscellaneous) &&
      (!value?.fileDescription || value?.fileDescription.trim().length === 0)
    ) {
      ctx.addIssue({
        path: [key, "fileDescription"],
        code: z.ZodIssueCode.custom,
        message: "File description is required for Labwork or Miscellaneous file types",
      })
    }
  }
})

export type ProductFilesFormValues = z.infer<typeof ProductFilesFormSchema>
